import type { ColumnsType } from 'antd/lib/table'
import { IntegrationProjects } from 'src/core/models/myIntegrations.model'
import {
  FormLabels,
  CustomTitle,
  CustomHeaderText,
  CustomProjectColumn,
  IntegrationProjectsActionsColumn,
  MyIntegrationListPurchaseAmountColumn
} from 'src/components'

const integrationProjectsListColumns: ColumnsType<IntegrationProjects> = [
  {
    title: () => <CustomHeaderText text='Id' />,
    dataIndex: 'id',
    sorter: (a: IntegrationProjects, b: IntegrationProjects) => {
      return a.id - b.id
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      return <div className='centered-div'>
        {record.id}
      </div>
    }
  },
  {
    title: () => <CustomHeaderText text={'developers.Project'} />,
    dataIndex: 'name',
    sorter: (a: IntegrationProjects, b: IntegrationProjects) => a.name.length - b.name.length,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) =>
      <CustomProjectColumn
        name={record.name}
        imageSource={record.project_image}
        year={record.vintage_items ? record.vintage_items[0]?.year : null}
      />
  },
  {
    title: () => <CustomHeaderText text={'developers.TotalTransaction'} />,
    responsive: ['sm'],
    dataIndex: 'integrationProjects',
    sorter: (a: IntegrationProjects, b: IntegrationProjects) => a.transactions_data.amount - b.transactions_data.amount,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      return <MyIntegrationListPurchaseAmountColumn
        symbol={record.currency_symbol}
        amount={record.transactions_data.amount}
        co2_amount={record.transactions_data.co2_amount}
      />
    }
  },
  {
    title: () => <CustomHeaderText text={'developers.StockAvailable'} />,
    responsive: ['sm'],
    dataIndex: 'integrationProjects',
    sorter: (a: IntegrationProjects, b: IntegrationProjects) => a.available_volume_credits - b.available_volume_credits,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      return (
        <div style={{ marginBottom: '-10px' }}>
          <FormLabels
            title={`${record.available_volume_credits?.toFixed(2)} tCO₂`}
            subtitle={`${record.average_stock_available} %`}
          />
        </div>
      )
    }
  },
  {
    title: () => <CustomHeaderText text={'developers.LastEdit'} isCentered />,
    responsive: ['sm'],
    dataIndex: 'Date',
    width: 140,
    sorter: (a, b) => {
      const dateA = new Date(a.modified)
      const dateB = new Date(b.modified)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, record) => {
      return (
        <div className='centered-div'>
          <CustomTitle label={record.modified} />
        </div>
      )
    }
  },
  {
    title: () => <CustomHeaderText text={'general.Actions'} isCentered />,
    align: 'center',
    render: (_, record) => {
      return (
        <div style={{ left: '1rem' }}>
          <IntegrationProjectsActionsColumn project={record} />
        </div>
      )
    },
  },
]

export default integrationProjectsListColumns
